export const convertTime = (time) => {
    return new Date(time).toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
    });
};
